import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f8b58f87"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "main",
  class: "d-flex flex-column align-items-start justify-content-start mx-auto"
}
const _hoisted_2 = { class: "px-2 py-4 w-100" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"row mx-0 w-100\" data-v-f8b58f87><div class=\"col-5 px-0\" id=\"img-outlet-container\" data-v-f8b58f87><div id=\"img-outlet\" data-v-f8b58f87><img src=\"/assets/soma_wellness/images/checkout-login/soma_logo_img.png\" alt=\"SOMA Logo Img\" data-v-f8b58f87></div></div><div class=\"col-7 pr-0 d-flex flex-column justify-content-center\" data-v-f8b58f87><div class=\"row mx-0\" data-v-f8b58f87><div class=\"col-12 px-0 d-flex justify-content-center\" data-v-f8b58f87><img id=\"soma-logo\" src=\"https://dr4y4dqumhrhn.cloudfront.net/soma_logo.png\" alt=\"SOMA Logo\" data-v-f8b58f87></div></div><div class=\"row mx-0 mt-4\" data-v-f8b58f87><div class=\"col-12 px-0 d-flex justify-content-center\" data-v-f8b58f87><img id=\"powered-by\" src=\"https://dr4y4dqumhrhn.cloudfront.net/powered_by.png\" alt=\"Powered By\" data-v-f8b58f87></div></div></div></div>", 1)
const _hoisted_4 = { class: "row mx-0 w-100 mt-4" }
const _hoisted_5 = { class: "col-12 px-0" }
const _hoisted_6 = { id: "timer-outer-container" }
const _hoisted_7 = {
  id: "timer-container",
  class: "d-flex justify-content-center"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/assets/soma_wellness/images/checkout-login/hourglass.png" }, null, -1 /* HOISTED */))
const _hoisted_9 = {
  id: "slot-held",
  class: "ml-4 pt-1"
}
const _hoisted_10 = { class: "row mx-0 w-100 mt-4" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 px-0 text-center information-text" }, " Secure your booking instantly with WhatsApp. No password needed! ", -1 /* HOISTED */))
const _hoisted_12 = {
  class: "col-12 px-0 mt-2",
  id: "login-div"
}
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/assets/soma_wellness/images/checkout-login/login.png" }, null, -1 /* HOISTED */))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mx-0 w-100 my-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 px-0 text-center information-text" }, " --- OR --- ")
], -1 /* HOISTED */))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mx-0 w-100" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 px-0 text-center information-text" }, " Button not working? Send this code to +60 13-644 6911 ")
], -1 /* HOISTED */))
const _hoisted_18 = { class: "row mx-2 w-100 mt-4" }
const _hoisted_19 = { class: "col-12 px-0 d-flex justify-content-center" }
const _hoisted_20 = {
  id: "otp",
  class: "pt-2"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "btn-copy",
  class: "ml-4",
  src: "/assets/soma_wellness/images/checkout-login/copy.png"
}, null, -1 /* HOISTED */))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mx-0 w-100 mt-8" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 px-0 text-center information-text" }, " Do not add extra text. ")
], -1 /* HOISTED */))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, "SLOT HELD FOR : " + _toDisplayString($options.format_minutes) + " mins", 1 /* TEXT */)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("a", {
            href: `https://api.whatsapp.com/send?phone=60136446911&text=Hi%20SOMA%20Wellness,%20I%20would%20like%20to%20Login%20with%20this%20WhatsApp%20number.%0A%0AOTP:%20${$data.otp}`,
            target: "_blank",
            onClick: _cache[0] || (_cache[0] = (...args) => ($options.track_whatsapp_login_click && $options.track_whatsapp_login_click(...args)))
          }, [..._hoisted_15], 8 /* PROPS */, _hoisted_13)
        ])
      ]),
      _hoisted_16,
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, " OTP: " + _toDisplayString($data.otp), 1 /* TEXT */),
          _createElementVNode("div", {
            class: "d-flex align-items-center",
            onClick: _cache[1] || (_cache[1] = (...args) => ($options.copy_otp && $options.copy_otp(...args)))
          }, [..._hoisted_22])
        ])
      ]),
      _hoisted_23
    ])
  ]))
}